import { Button } from '@/components/ui/button'

interface Props {
  onClick: () => void
  type?: 'submit' | 'button'
  className?: string
  text: string
  disabled?: boolean
  variant?:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link'
    | null
    | undefined
}
export const ButtonPrimary = ({
  onClick,
  text,
  type,
  className,
  disabled,
  variant,
}: Props) => {
  return (
    <Button
      variant={variant ? variant : 'default'}
      onClick={onClick}
      disabled={disabled}
      className={className}
      type={type ?? 'button'}
    >
      {text}
    </Button>
  )
}
